export const formatBreadcrumbLabel = (label) => {
  if (typeof label !== "string") return label;
  return label.toLowerCase().replace(/(^|[^\p{L}\p{M}\p{N}'’])(\p{L})/gu,
    (_, prefix, letter) => prefix + letter.toUpperCase());
};
